/**
 * PostHog experiment / feature-flag keys.
 *
 * One source of truth for flag names so frontend, backend, and PostHog UI all
 * reference the same string. When adding a new experiment, document the flag
 * in `docs/experiments/<flag-key>.md`.
 */
export const EXPERIMENT_FLAGS = {
  /**
   * scio3b-split — 50/50 A/B test on the signup → onboarding experience.
   * Variants: `scio3a` (control, current UX) | `scio3b` (treatment).
   * See `docs/experiments/scio3b-split.md`.
   */
  SCIO3B_SPLIT: 'scio3b-split',
} as const;

export type ExperimentFlagKey = (typeof EXPERIMENT_FLAGS)[keyof typeof EXPERIMENT_FLAGS];

/** Variants for the SCIO3B_SPLIT experiment. */
export type OnboardingVariant = 'scio3a' | 'scio3b';
